/// <reference types="@types/google.maps" />
import { Component, EventEmitter, OnInit, Output, DOCUMENT } from '@angular/core';
import { Injectable, Inject, Injector } from '@angular/core';

import { Input, Renderer2, ElementRef } from '@angular/core';


// const GOOGLE_API_KEY = "AIzaSyDZStYkYrI_h8dQORO39AAAeZ_CwvdIOHU"; // TODO
const GOOGLE_API_KEY = "AIzaSyCFoM8uV1hX74sTCmAStPSKgwbT-txyty0";

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";
import { BtEvent } from '../../../services/event.service';


@Component({
    selector: 'bt-google-maps',
    host: { '[class.map-enabled]': 'mapEnabled' },
    imports: [LibModulesWolcModule],
    templateUrl: './bt-google-maps.component.html',
    styleUrl: './bt-google-maps.component.scss'
})
export class BtGoogleMapsComponent {
  bas = inject(BooktechAppService);

  @Input('params') params: any = { };
  @Input() compactInfoWindow: boolean = false; // Remove padding and close button for Airbnb-style popups
  @Output() mapClick = new EventEmitter<any>();
  @Output() mapSelectPosition = new EventEmitter<google.maps.LatLng>();

  public map: google.maps.Map | undefined = undefined;
  public markers: google.maps.Marker[] = [];
  private openInfoWindow:google.maps.InfoWindow | undefined = undefined;
  public mapEnabled: boolean = false;
  private mapsLoaded: boolean = false;
  public isReady: boolean = false;
  private readyPromise: Promise<any> | undefined = undefined;
  private networkHandler = null;
  private selectPositionMarker :google.maps.Marker|undefined = undefined;

  private renderer: Renderer2 = inject(Renderer2);
  private element: ElementRef = inject(ElementRef);
  private _document: Document = inject(DOCUMENT);

  private activatedResolve?: () => void;
  private activatedPromise = new Promise<void>(resolve => this.activatedResolve = resolve);


  constructor( ) {

      

   }

  ngOnInit() {
    let enableMap =   this.params.mapEnabled || (this.bas.nossr &&  this._document.getElementById("googleMaps") != null );
    if (!enableMap && this.params.mapEnabled !== false) {
      enableMap = this.bas.settings.appId === "cbadmin";
    }
    if (enableMap) {
      this.enableMap();
    }
  }

  public enableMap() {

    if (this.mapEnabled) {
      return;
    }
    this.mapEnabled = true;
    this.activatedResolve?.();
    this.ensureInitStarted().catch(err => {
      if(this.bas.envtest) console.log(err);
    });
  }

  private ensureInitStarted(): Promise<any> {
    if (this.readyPromise) {
      return this.readyPromise;
    }
    this.readyPromise = this.init().then((res) => {
      this.isReady = true;
      if (this.bas.envtest) console.log("Google Maps ready.");
      this.bas.es.trigger(BtEvent.GoogleMapsReady);
      return res;
    });
    return this.readyPromise;
  }

  public async ready(): Promise<any> {
    await this.activatedPromise;
    await this.ensureInitStarted();
    return true;
  }

  private init(): Promise<any> {
    //console.log("init");
    return new Promise((resolve, reject) => {

        this.loadSDK().then((res) => {

            this.initMap().then((res) => {
                resolve(true);
            }, (err) => {
                reject(err);
            });

        }, (err) => {

            reject(err);

        });

    });

}

private loadSDK(): Promise<any> {

    if(this.bas.envtest) console.log("Loading Google Maps SDK");

    return new Promise((resolve, reject) => {

        if(!this.mapsLoaded){

            // Network.getStatus().then((status) => {

            //     if(status.connected){

            //         this.injectSDK().then((res) => {
            //             resolve(true);
            //         }, (err) => {
            //             reject(err);
            //         });

            //     } else {

            //         if(this.networkHandler == null){

            //             this.networkHandler = Network.addListener('networkStatusChange', (status) => {

            //                 if(status.connected){

            //                     this.networkHandler.remove();

            //                     this.init().then((res) => {
            //                         if(this.bas.envtest) console.log("Google Maps ready.")
            //                     }, (err) => {    
            //                         if(this.bas.envtest) console.log(err);
            //                     });

            //                 }

            //             });

            //         }

            //         reject('Not online');
            //     }

            // }, (err) => {

                // NOTE: navigator.onLine temporarily required until Network plugin has web implementation
                if(this.bas.ssr || navigator.onLine){

                    this.injectSDK().then((res) => {
                        resolve(true);
                    }, (err) => {
                        reject(err);
                    });

                } else {
                    reject('Not online');
                }

            // });

        } else {
            // reject('SDK already loaded');
             
          resolve(true);
        }

    });


}

private injectSDK(): Promise<any> {

    return new Promise((resolve, reject) => {

      let script = this._document.getElementById("googleMaps") as HTMLScriptElement;
      if (script) {
        if(this.bas.envtest) console.log("already loaded: ", script);
        resolve(true);
        return;
      }

      if(this.bas.envtest) console.log("script == false: ", script);
      
      if (this.bas.nossr) {
        let win:any = this.bas.nossr ? window : undefined;
        if(win) win['mapInit'] = () => {
            this.mapsLoaded = true;
            resolve(true);
        }
  
        script = this.renderer.createElement('script') as HTMLScriptElement;
        script.id = 'googleMaps';
  
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_API_KEY + '&callback=mapInit';
        
  
        this.renderer.appendChild(this._document.body, script);
      }


    });

}

private initMap(): Promise<any> {


    return new Promise((resolve, reject) => {
      // console.log("params: ", this.params);
      let lat = this.params.coords?.latitude || 59.913490;  // Default:
      let lng = this.params.coords?.longitude || 10.752089  // Oslo sentrum

      let latLng = new google.maps.LatLng(lat, lng);

      let mapOptions = {
          center: latLng,
          zoom: this.params.zoom || 15    //
      };

      // .querySelector("#google-map-div")
      this.map = new google.maps.Map(this.element.nativeElement, mapOptions);
      this.addEventsListeners();
      resolve(true);


        /*
        Geolocation.getCurrentPosition().then((position) => {

            if(this.bas.envtest) console.log(position);

            let latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

            let mapOptions = {
                center: latLng,
                zoom: 15
            };

            this.map = new google.maps.Map(this.element.nativeElement, mapOptions);
            resolve(true);

        }, (err) => {

            reject('Could not initialise map');

        });
      */

    });

  }

  private addEventsListeners() {
    let selectPosition = !!this.params.selectPosition;

    if (selectPosition && this.params.coords) {
      let lat = this.params.coords?.latitude;
      let lng = this.params.coords?.longitude;

      let latLng = new google.maps.LatLng(lat, lng);

      this.selectPositionMarker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP,
        position: latLng
      });
      this.markers.push(this.selectPositionMarker);

    }

    this.map?.addListener("click", (event:any) => {
      this.mapClick.next(event);

      if (selectPosition) {
        let latLng = event.latLng;
        if (this.selectPositionMarker) {

          this.selectPositionMarker.setPosition(latLng);
        } else {
          this.selectPositionMarker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: latLng
          });
          this.markers.push(this.selectPositionMarker);
        }

        this.mapSelectPosition.next(latLng);
      }
    });
  }

  public addMarker(lat: number, lng: number, infoWindowElement:HTMLElement | null): google.maps.Marker {  // |String

    let latLng = new google.maps.LatLng(lat, lng);

    let marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP,
        position: latLng
    });

    if (infoWindowElement) {
      //let gmc = this;
      google.maps.event.addListener(marker, 'click', (event:any) => {
        if (this.openInfoWindow) {
          //console.log("Closing existing");
          this.openInfoWindow.close();
          this.openInfoWindow = undefined;
        }
        this.openInfoWindow = new google.maps.InfoWindow({
          content: infoWindowElement,
          maxWidth: 320,
          disableAutoPan: false
        });

        this.openInfoWindow.open(this.map!, marker);

        // Remove default Google Maps InfoWindow styling after open (if compact mode enabled)
        if (this.compactInfoWindow) {
          google.maps.event.addListenerOnce(this.openInfoWindow, 'domready', () => {
            const iwContainer = document.querySelector('.gm-style-iw-c');
            if (iwContainer) {
              (iwContainer as HTMLElement).style.padding = '0';
              (iwContainer as HTMLElement).style.borderRadius = '12px';
            }
            const iwOuter = document.querySelector('.gm-style-iw');
            if (iwOuter) {
              (iwOuter as HTMLElement).style.padding = '0';
              (iwOuter as HTMLElement).style.overflow = 'visible';
            }
            const iwContent = document.querySelector('.gm-style-iw-d');
            if (iwContent) {
              (iwContent as HTMLElement).style.overflow = 'hidden';
              (iwContent as HTMLElement).style.maxWidth = 'none';
            }
            // Hide default close button
            const closeBtn = document.querySelector('.gm-style-iw-chr');
            if (closeBtn) {
              (closeBtn as HTMLElement).style.display = 'none';
            }
          });
        }

      });

    }


    this.markers.push(marker);

    return marker;
  }

  // Airbnb-style price marker using OverlayView
  public addPriceMarker(lat: number, lng: number, price: string, infoWindowElement:HTMLElement | null, productId?: string): any {
    if (!this.map) {
      console.error('Map not initialized');
      return null;
    }

    const PriceMarkerOverlay = this.createPriceMarkerOverlayClass();

    const overlay = new PriceMarkerOverlay(
      new google.maps.LatLng(lat, lng),
      price,
      this.map,
      infoWindowElement,
      this,
      productId
    );

    // Add to our tracking array
    this.priceOverlays.push(overlay);

    return overlay;
  }

  private createPriceMarkerOverlayClass(): any {
    const self = this;

    // Define the custom overlay class
    class PriceMarkerOverlay extends google.maps.OverlayView {
      private position: google.maps.LatLng;
      private price: string;
      private containerDiv: HTMLElement | null = null;
      private infoWindowElement: HTMLElement | null;
      private mapComponent: BtGoogleMapsComponent;
      private productId: string | undefined;
      private isSelected: boolean = false;

      constructor(
        position: google.maps.LatLng,
        price: string,
        map: google.maps.Map,
        infoWindowElement: HTMLElement | null,
        mapComponent: BtGoogleMapsComponent,
        productId?: string
      ) {
        super();
        this.position = position;
        this.price = price;
        this.infoWindowElement = infoWindowElement;
        this.mapComponent = mapComponent;
        this.productId = productId;
        this.setMap(map);
      }

      override onAdd() {
        this.containerDiv = document.createElement('div');
        this.containerDiv.className = 'map-price-marker';
        this.containerDiv.innerHTML = `<span class="map-price-text">${this.price}</span>`;

        // Add click handler
        this.containerDiv.addEventListener('click', (e) => {
          e.stopPropagation();
          this.select();
          if (this.infoWindowElement) {
            this.mapComponent.openInfoWindowForOverlay(this.position, this.infoWindowElement, this);
          }
        });

        const panes = this.getPanes();
        if (panes) {
          panes.overlayMouseTarget.appendChild(this.containerDiv);
        }
      }

      override draw() {
        const overlayProjection = this.getProjection();
        if (!overlayProjection || !this.containerDiv) return;

        const pixel = overlayProjection.fromLatLngToDivPixel(this.position);
        if (pixel) {
          // Center the marker horizontally and position above the point
          const width = this.containerDiv.offsetWidth || 60;
          this.containerDiv.style.left = (pixel.x - width / 2) + 'px';
          this.containerDiv.style.top = (pixel.y - 40) + 'px';
        }
      }

      override onRemove() {
        if (this.containerDiv && this.containerDiv.parentNode) {
          this.containerDiv.parentNode.removeChild(this.containerDiv);
        }
        this.containerDiv = null;
      }

      select() {
        this.isSelected = true;
        if (this.containerDiv) {
          this.containerDiv.classList.add('selected');
        }
        // Deselect other markers
        this.mapComponent.priceOverlays.forEach(overlay => {
          if (overlay !== this && overlay.deselect) {
            overlay.deselect();
          }
        });
      }

      deselect() {
        this.isSelected = false;
        if (this.containerDiv) {
          this.containerDiv.classList.remove('selected');
        }
      }
    }

    return PriceMarkerOverlay;
  }

  public priceOverlays: any[] = [];

  public openInfoWindowForOverlay(position: google.maps.LatLng, content: HTMLElement, overlay: any) {
    if (this.openInfoWindow) {
      this.openInfoWindow.close();
    }

    this.openInfoWindow = new google.maps.InfoWindow({
      content: content,
      maxWidth: 320,
      disableAutoPan: false
    });

    // Create a temporary marker for positioning
    const tempMarker = new google.maps.Marker({
      position: position,
      visible: false,
      map: this.map!
    });

    this.openInfoWindow.open(this.map!, tempMarker);

    // Handle close to deselect marker
    google.maps.event.addListenerOnce(this.openInfoWindow, 'closeclick', () => {
      if (overlay && overlay.deselect) {
        overlay.deselect();
      }
      tempMarker.setMap(null);
    });

    // Apply compact styling
    if (this.compactInfoWindow) {
      google.maps.event.addListenerOnce(this.openInfoWindow, 'domready', () => {
        const iwContainer = document.querySelector('.gm-style-iw-c');
        if (iwContainer) {
          (iwContainer as HTMLElement).style.padding = '0';
          (iwContainer as HTMLElement).style.borderRadius = '12px';
        }
        const iwOuter = document.querySelector('.gm-style-iw');
        if (iwOuter) {
          (iwOuter as HTMLElement).style.padding = '0';
          (iwOuter as HTMLElement).style.overflow = 'visible';
        }
        const iwContent = document.querySelector('.gm-style-iw-d');
        if (iwContent) {
          (iwContent as HTMLElement).style.overflow = 'hidden';
          (iwContent as HTMLElement).style.maxWidth = 'none';
        }
        const closeBtn = document.querySelector('.gm-style-iw-chr');
        if (closeBtn) {
          (closeBtn as HTMLElement).style.display = 'none';
        }
      });
    }
  }

  public clearPriceMarkers() {
    this.priceOverlays.forEach(overlay => {
      overlay.setMap(null);
    });
    this.priceOverlays = [];
  }

  public removeMarker(marker:google.maps.Marker) {
    marker.setMap(null);
    this.markers.splice(this.markers.indexOf(marker), 1);
    
  }

  public clearMarkers() {
    for (let m of this.markers) {
      m.setMap(null);
    }

    this.markers.splice(0, this.markers.length);

  }

  public closeInfoWindow() {
    if (this.openInfoWindow) {
      this.openInfoWindow.close();
      this.openInfoWindow = undefined;
    }
  }


  public centerMap() {
    // Collect all marker positions (both regular markers and price overlays)
    const allPositions: google.maps.LatLng[] = [];

    // Add regular marker positions
    for (let mm of this.markers) {
      const pos = mm.getPosition() as google.maps.LatLng;
      if (pos) allPositions.push(pos);
    }

    // Add price overlay positions
    for (let overlay of this.priceOverlays) {
      if (overlay.position) allPositions.push(overlay.position);
    }

    if (allPositions.length == 0) return;

    let setCenter = true;
    let llb = new google.maps.LatLngBounds();
    let allEqual = true;
    let prev: google.maps.LatLng = allPositions[0];

    for (let pos of allPositions) {
      llb.extend(pos);
      if (!prev.equals(pos)) {
        allEqual = false;
      }
    }

    if (!allEqual) {
      this.map!.fitBounds(llb);
      setCenter = false;
    }

    if(this.bas.envtest) console.log("centerMap, size: " + allPositions.length + ", eq: " + allEqual + "; sc: " + setCenter + ", map.bounds: " + this.map?.getBounds());

    if (setCenter) this.map!.setCenter(llb.getCenter());
  }

}


